import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useAfterCookieBannerContext } from '../../context/afterCookieBannerContext';
import { useDidMount } from '../../hooks/useDidMount';
import { useGeoIp } from '../../hooks/useGeoIp';
import { Cookies } from '../../utils/cookies';

/* eslint-disable promise/prefer-await-to-then */
const NoLocationPopUp = dynamic(
  () =>
    import(/* webpackChunkName: "NoLocationPopUp" */ '../popUps/NoLocationPopUp').then((mod) => mod.NoLocationPopUp),
  { ssr: false },
);

const RedirectPopUp = dynamic(
  () => import(/* webpackChunkName: "RedirectPopUp" */ '../popUps/RedirectPopUp').then((mod) => mod.RedirectPopUp),
  { ssr: false },
);
/* eslint-enable promise/prefer-await-to-then */

export function GeoIpPopUp() {
  const isMounted = useDidMount();
  const { promptRedirectAfterCookie, setPromptRedirectAfterCookie } = useAfterCookieBannerContext();

  const { hasLocationInfo, loadingGeoIpInfo, showRedirectPopUp, redirectInfo } = useGeoIp();

  useEffect(() => {
    if (isMounted && !loadingGeoIpInfo) {
      setPromptRedirectAfterCookie(Cookies.get('OptanonAlertBoxClosed'));
    }
  }, [isMounted, loadingGeoIpInfo, setPromptRedirectAfterCookie]);

  if (loadingGeoIpInfo || !promptRedirectAfterCookie) return null;

  return (
    <>
      {!hasLocationInfo && <NoLocationPopUp hasLocationInfo={hasLocationInfo} />}
      {showRedirectPopUp && <RedirectPopUp redirectInfo={redirectInfo} />}
    </>
  );
}

export default GeoIpPopUp;
